import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { Observable } from 'rxjs';
import { GlobalsService } from '../globals.service';
import { Partner } from 'src/app/models/services/audiences/ttd/partner';

@Injectable({
  providedIn: 'root'
})
export class TtdAudiencesService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) { }

  public getPartners(): Observable<Partner[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/ttd/partners`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }  

}